<template>
	<BasicButton v-if="!isLoggedIn" :blocked="true" color="tertiary" @click="openModal">
		<span v-html="$t('WEBAPP_LOGINS_SIGNIN_CTA')"></span>
	</BasicButton>
</template>

<script setup lang="ts">
import { AccountModal } from '@/lazy-load-components';
import BasicButton from '@/ui-components/BasicButton.vue';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { storeToRefs } from 'pinia';

withDefaults(defineProps<{ location: string }>(), { location: '' });
const userStore = useUserStore();
const { setLoginProgress } = userStore;
const { isLoggedIn } = storeToRefs(userStore);

function openModal() {
	ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, [], () =>
		setLoginProgress(false)
	);
}
</script>

<style lang="scss"></style>
